<template>
  <div class="couponContainer" v-if="pageVisible">
    <div class="grid imgGrid">
      <img class="imgContainer" src="@/assets/images/mosquita_rocket.png" />
      <p class="nunitoBold subheaderText">{{ $t('k_promotion_active') }}</p>
      <p
        class="ralewayRegular subheaderText2"
        v-html="$t('k_enable_promotion')"
      ></p>
    </div>
    <form action="#" @submit.prevent="submit">
      <div class="grid mt-10">
        <div class="stButton registerButton">
          <div class="stButtonCaption nunitoBold" v-on:click="downloadSmart">
            {{ $t('k_download_smart') }}
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { getStripeObject } from '../plugins/stripe'
import api from '.././plugins/api'

export default {
  data() {
    return {
      pageVisible: false
    }
  },
  async mounted() {
    this.session_id = this.$route.query.session_id
    await this.initialize()
  },
  methods: {
    downloadSmart: function() {
      location.replace(
        'https://smarttales.app/get.php?lang=[in/en]&ref=couponLanding'
      )
    },
    initialize: async function() {
      this.stripe = await getStripeObject()

      const sessionUrl = `${process.env.VUE_APP_BACKEND_URL}/user/stripe/session?&session_id=${this.session_id}`
      const sessionResponse = await api.get(sessionUrl, {
        headers: { Authorization: process.env.VUE_APP_CONTROL_KEY }
      })
      if (sessionResponse.data.status == 'open') {
        this.$router.push({
          path: '/checkout',
          query: { ...this.$route.query, error: true }
        })
      } else {
        if (this.$route.query.next_url)
          window.location = this.$route.query.next_url
        else {
          this.pageVisible = true
        }
      }
    }
  }
}
</script>
<style lang="scss">
.couponContainer {
  .subheaderText2 {
    text-align: center;
  }
  .registerButton {
    grid-row: 1;
    grid-column: 2/12;
    padding: 10px 0px;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .buttonCaption {
    grid-row: 1;
    grid-column: 4/13;
    display: flex;
    font-size: 1.1875em;
  }

  .stButtonCaption {
    grid-row: 1;
    grid-column: 1/13;
    font-size: 1.1875em;
  }

  .formContainer {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .formElement {
    grid-column: 2/12;
  }

  .formInputLabel {
    display: flex;
    font-size: 1em;
    color: var(--formColor);
  }
  .formInput {
    padding: 10px 15px;
    width: 100%;
    border-radius: 5px;
    border: 1px solid var(--outlineInput);
    font-size: 1em;
    color: var(--formColor);
  }

  .checkboxLabel {
    font-size: 0.688em;
    color: var(--formColor);
    grid-column: 3/8;
  }

  .accept {
    display: flex;
    grid-column: 2/3;
    align-self: center;
  }
  @media screen and (min-width: 620px) {
  }
  /* large tablet and laptop styles */
  @media screen and (min-width: 960px) {
  }
  /* desktop styles */
  @media screen and (min-width: 1200px) {
  }
}
</style>
